module.exports = __webpack_public_path__ + "static/coin-index-90ccfd10a61d9fc32f396ad39cd6227c.png";